<template>
  <div>
    <CardedForm
      ref="districts_form_ref"
      id="districts_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <TextField
        v-model="form.name"
        :validation_rules="form_validations.name"
        label="Name Of District"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
    </CardedForm>
  </div>
</template>

<script>
import CardedForm from "../../../components/CardedForm";
import TextField from "../../../components/TextField";
import Utils from "../../../lib/Utils";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminDistrictsAdd",
  components: {
    CardedForm,
    TextField
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_editing: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      errors: [],
      message: "",
      form: {
        name: "",
      },
      form_validations: {
        name: [
          Utils.validate.is_required("District name is required"),
          Utils.validate.min_max_length(
            2,
            30,
            "DIstrict name should be between 2 and 30 characters "
          ),
        ]
      },
      edit_district_id: 0
    };
  },
  methods: {
    on_auto_fill() {
      this.init_form();
      var rnd = Math.ceil(Math.random() * 999);
      this.form.name = "district_name_" + rnd;
    },
    init_form() {
      this.form.name = "";
      this.errors = [];
      this.message= "";
      this.$refs.districts_form_ref.on_clear_form();
    },
    submit() {
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      if(this.is_editing == true){
        ServerClient.Locations.update_district({
            id: this.edit_district_id,
            ... this.form
          }, (res) => {
          console.log("edit district res",res);
          this.$emit("on-hide-loader");
          this.message = "<b>Edit Was Successfull</b> <br/>  District has been edited";
          this.$refs.districts_form_ref.show_message_dialog();
        }, (errors) => {
          console.log("edit districts errors",errors);
          this.errors = errors;
          this.$refs.districts_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        });
      }else{
        ServerClient.Locations.post_district(this.form, (res) => {
          console.log("add district res",res);
          this.$emit("on-hide-loader");
          this.message = "<b>Operation Was Successfull</b> <br/>  District was added";
          this.$refs.districts_form_ref.show_message_dialog();
        }, (errors) => {
          console.log("add districts errors",errors);
          this.errors = errors;
          this.$refs.districts_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        });
      }
    },
    on_hide_message() {
      if(this.is_editing == true){
        this.$emit("on-success-edit");
      }else{
        this.init_form();
      }
    },
    fill_edit_district(district) {
      console.log("district to be edited ", district);
      this.edit_district_id = district.id;
      this.form.name = district.name;
      this.errors = [];
      this.message = "";
    },
  },
  mounted() {
    this.$emit("set-page-attributes", {
      title: "Add A District",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "New District",
          disabled: true,
          href: "/admin/locations/districts/add",
        },
      ],
    });
    this.init_form();
  },
};
</script>